import { useLocation, useSearchParams } from 'react-router-dom';
import { useCustomSearch } from '../../../../../shared/hook/useCustomSearch';
import { deviceOptions, getSelectValue } from '../../../../../shared/constants/commonCode';
import CustomSearch from '../../../../ui/search/customSearch';
import * as C from '../../../../ui/common/CommonStyles';
import * as M from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { DISPATCH_TARGET, DispatchTarget } from '../../../../../shared/constants/dispatchTarget';
import ExcelRegisterModal from '../Modal/ExcelRegisterModal';
import { useModelSelect } from './hooks/useModelSelect';
import Swal from 'sweetalert2';
import { queryClient } from '../../../../../shared/queryClient';
import { showSuccessNotification } from '../../../../ui/notification';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../shared/types';
import { handleError } from '../../../../ui/err/handleError';
import { useDispatchMutation } from './hooks/useDispatchMutation';
import { useCheckbox } from '../../../../../shared/hook/useCheckbox';
import ControlSections from './sections/controlSection';
import DispatchTable from './sections/dispatchTable';

interface IDispatchListProps {
  target: DispatchTarget;
  initSearchType?: string;
}

export default function DispatchList(props: IDispatchListProps) {
  const { target, initSearchType } = props;

  const [searchParams] = useSearchParams('');
  const searchTypeUrl = searchParams.get('searchType') || initSearchType;
  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({ initType: initSearchType });

  const currentPathname = useLocation().pathname;
  const isEndUser = currentPathname.includes('end-user');

  const [opened, { open, close }] = useDisclosure(false);
  const { deviceCd, deviceSubCd, onChangeDeviceParams } = useModelSelect();
  const { selectedIds, onSelectRow, onSelectAllRows } = useCheckbox();

  const { deleteDevice } = useDispatchMutation();

  const onClickDeleteDevice = () => {
    if (selectedIds.size === 0) {
      Swal.fire({
        icon: 'warning',
        title: '선택된 출고 디바이스가 없습니다.',
        confirmButtonText: '확인',
      });
      return;
    }

    Swal.fire({
      title: '출고 디바이스 삭제',
      text: '선택한 출고 디바이스가 삭제됩니다. 삭제하시겠습니까?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: '취소',
      confirmButtonText: '확인',
    }).then((result) => {
      if (result.isConfirmed) {
        deleteDevice(
          { ids: Array.from(selectedIds) },
          {
            onSuccess: () => {
              showSuccessNotification('삭제 되었습니다.');
              queryClient.invalidateQueries(['getDispatchList']);
            },
            onError: (error: unknown) => {
              handleError(error as AxiosError<AxiosCommonError>);
            },
          },
        );
      }
    });
  };
  return (
    <div>
      <C.TitleBox>
        <div className="title">출고 관리({DISPATCH_TARGET[target.value].label})</div>
      </C.TitleBox>
      <C.ListBox>
        <M.Group justify="space-between" align="flex-end">
          <M.Group gap="sm" align="flex-end">
            <M.Select
              data={deviceOptions}
              style={{ width: '140px' }}
              value={getSelectValue(deviceCd, deviceSubCd)}
              label="모델명"
              onChange={(_value, option) => onChangeDeviceParams(option)}
            />
            <CustomSearch
              resetSearch={resetWord}
              resetSearchInput={resetSearchInput}
              searchType={searchTypeUrl}
              setSearchType={handleSearchType}
              inputRef={inputRef}
              handleSearch={handleSearch}
              searchOptions={[
                { value: 'to', label: '입고 거래처' },
                { value: 'from', label: '출고 거래처' },
                { value: 'mac', label: 'MAC' },
              ]}
            />
          </M.Group>
          <ControlSections
            isEndUser={isEndUser}
            currentPathname={currentPathname}
            onClickDeleteDevice={onClickDeleteDevice}
            open={open}
          />
        </M.Group>
        <M.Space h="md" />
        <DispatchTable
          initSearchType={initSearchType}
          selectedIds={selectedIds}
          onSelectRow={onSelectRow}
          onSelectAllRows={onSelectAllRows}
          deviceCd={deviceCd}
          deviceSubCd={deviceSubCd}
        />
      </C.ListBox>
      {opened && <ExcelRegisterModal opened={opened} close={close} />}
    </div>
  );
}
